<style scoped lang="less">
.pdf {
    position: absolute;
    top: 0;
    left: 0;
    width: 800px;
    display: flex;
    flex-direction: column;
    > img {
        width: 100%;
    }
}
.upload-container {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 350px;
    margin: 0 auto;
}
</style>

<template>
    <div>
        <div class="upload-container">
            <el-card class="box-card" :body-style="{ padding: '10px' }">
                <el-upload ref="upload" size="mini" class="upload-demo" list-type="picture" action="#" multiple :auto-upload="false" :on-change="handleChange" :on-remove="handleRemove">
                    <el-button slot="trigger" size="mini" type="primary" round>选取文件 ({{imgList.length}})</el-button>
                    <el-button style="margin-left: 10px;" size="mini" type="success" @click.stop="download" round>下载</el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click.stop="clearList()" circle></el-button>
                </el-upload>
            </el-card>
        </div>
        <div class="pdf" id="pdf">
            <img :src="file.url" v-for="file in imgList">
        </div>
    </div>
</template>

<script>
import { HttpClient } from "../util/http";
import { actionConfirm, msgSuccess } from "../util/toast";
import { pdfUtils } from "../util/pdfUtils";
import dayjs from "dayjs";

export default {
    data() {
        return {
            imgList: []
        };
    },
    computed: {},
    components: {},
    created() {},
    methods: {
        async download() {
            if (!this.imgList.length) {
                return this.$message.error("未上传图片");
            }
            pdfUtils.imgs2Pdf2(
                document.getElementById("pdf"),
                dayjs().format("YYYYMMDD-HHmmss-") + this.imgList.length
            );
        },
        handleChange(file, fileList) {
            this.imgList = fileList;
        },
        handleRemove(file, fileList) {
            this.imgList = fileList;
        },
        async clearList() {
            await actionConfirm();
            this.imgList = [];
            this.$refs.upload.clearFiles();
        }
    }
};
</script>


        